if (!customElements.get('media-text-swiper')) {
    class MediaTextSwiper extends HTMLElement {
        // 私有字段定义
        #swiperContainer = null;
        #thumbSwiper = null;
        #swiperInstance = null; // Swiper实例
        #thumbSwiperInstance = null; // Swiper实例
        players = [];

        constructor() {
            super();
            this.videoMedia = null; // 延迟初始化
        }

        connectedCallback() {
            this.videoMedia = this.querySelectorAll('[data-media-type="video"]');
            this.#initializeSwiperContainer();
            this.initPlyr();
            this.clickPlayer();
            this.toggleContent();
        }

        disconnectedCallback() {
            this.#destroySwiper();
            this.#destroyPlyr(); // 销毁 Plyr 实例
        }

        toggleContent() {
            let isAnimating = false; // 动画执行状态标志

            this.addEventListener('click', (event) => {
                const toggleButton = event.target.closest('.media-text-swiper__main_item__title');
                if (toggleButton) {
                    // 如果当前正在执行动画，则不执行新的动画
                    // console.log("toggleButton clicked");
                    if (isAnimating) return;
                    const parent = toggleButton.closest('.media-text-swiper__main_item');
                    const content = parent.querySelector('.media-text-swiper__main_item__content');
                    if(!content) return;
                    // console.log("toggleButton执行");
                    if(parent){
                        parent.classList.toggle('active');
                    }
                    isAnimating = true; // 设置动画状态为 true，表示正在执行动画

                    $(content).slideToggle({
                        step: () => {
                            this.#swiperInstance.updateAutoHeight(); // 在每一步动画时更新 Swiper 实例
                        },
                        complete: () => {
                            isAnimating = false; // 动画完成后重置状态为 false
                        }
                    });
                }
            });
        }

        clickPlayer() {
            // 事件委托：将点击事件绑定到父元素
            this.addEventListener('click', (event) => {
                // 使用 closest() 方法查找最近的 .media-text-swiper__main_item__media_player 元素
                const playerButton = event.target.closest('.media-text-swiper__main_item__media_player');

                if (playerButton) {
                    // 获取当前点击的 .media-text-swiper__main_item__media_player 的父元素
                    const videoItem = playerButton.closest('[data-media-type="video"]');

                    if (videoItem) {
                        // 隐藏 .media-text-swiper__main_poster 和 .media-text-swiper__main_item__media_player 元素
                        const poster = videoItem.querySelector('.media-text-swiper__main_poster');

                        if (poster) poster.style.display = 'none';
                        if (playerButton) playerButton.style.display = 'none';

                        // 给父元素添加 active 类名
                        videoItem.classList.add('active');
                        const videoElement = videoItem.querySelector('video');
                        if (videoElement) {
                            videoElement.play();
                            this.#swiperInstance.updateAutoHeight();
                        }
                    }
                }
            });
        }

        initPlyr() {
            const plyrVideoElements = this.querySelectorAll("[data-plyr-video]");

            // 确保每个 plyr 实例都被存储在 players 数组中
            plyrVideoElements.forEach((plyrVideoElement) => {
                const player = new Plyr(plyrVideoElement, {
                    autoplay: true,
                    resetOnEnd: true,
                    loop: {
                        active: true,
                    },
                    controls: [
                        'play-large',
                        'play',
                        'progress',
                        'current-time',
                        'duration',
                        'fullscreen',
                    ],
                    tooltips: {
                        controls: false,
                        seek: false,
                    },
                    youtube: {
                        loop: 1,
                        title: false,
                        showinfo: 0,
                        rel: 0,
                    },
                    muted: true,
                    quality: { default: 1080, options: [4320, 2880, 2160, 1440, 1080, 720] },
                });
                this.players.push(player); // 保存每个 Plyr 实例
            });
        }

        #destroyPlyr() {
            // 销毁 Plyr 实例
            this.players.forEach(player => player.destroy());
            this.players = [];
        }

        #initializeSwiperContainer() {
            this.#thumbSwiper = this.querySelector('.media-text-swiper__thumb_box');
            this.#swiperContainer = this.querySelector('.media-text-swiper__main_box');

            if (this.#thumbSwiper) {
                this.#initializeSwitchSwiper();
            } else {
                console.error('Switch swiper 容器未找到');
            }

            if (this.#swiperContainer) {
                this.#initializeContentSwiper();
            } else {
                console.error('Swiper 容器未找到');
            }
        }

        #initializeSwitchSwiper() {
            if (this.#thumbSwiperInstance) {
                console.warn('SwitchSwiper 实例已存在，跳过初始化');
                return; // 防止重复初始化
            }
            const nextButton = this.querySelector('.media-text-swiper__thumb_box-outer .swiper-button-next');
            const prevButton = this.querySelector('.media-text-swiper__thumb_box-outer .swiper-button-prev');

            const swiperParams = {
                slidesPerView: 5,
                spaceBetween: 15,
                direction: 'vertical',
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    320: {
                        spaceBetween: 3,
                        slidesPerView: 3,
                        direction: 'horizontal',
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        direction: 'horizontal',
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        direction: 'vertical',
                    },
                    1281: {
                        slidesPerView: 5,
                        spaceBetween: 15,
                        direction: 'vertical',
                    },
                },
            };

            this.#thumbSwiperInstance = new Swiper(this.#thumbSwiper, swiperParams);
        }

        #initializeContentSwiper() {
            if (this.#swiperInstance) {
                console.warn('ContentSwiper 实例已存在，跳过初始化');
                return; // 防止重复初始化
            }

            const swiperParams = {
                slidesPerView: 1,
                spaceBetween: 10,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                thumbs: {
                    swiper: this.#thumbSwiperInstance,
                },
                allowTouchMove: false,
                autoHeight: true,
                observer: true,
                observeSlideChildren: true,
            };

            this.#swiperInstance = new Swiper(this.#swiperContainer, swiperParams);
        }

        #destroySwiper() {
            if (this.#swiperInstance) {
                this.#swiperInstance.destroy(true, true);
                this.#swiperInstance = null;
            }
            if (this.#thumbSwiperInstance) {
                this.#thumbSwiperInstance.destroy(true, true);
                this.#thumbSwiperInstance = null;
            }
        }
    }

    customElements.define('media-text-swiper', MediaTextSwiper);
}
